import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const clientLedgerReducer = (state = initialState.clientLedger, action) => {
  switch (action.type) {
    case types.CREATE_CLIENT_LEDGER_SUCCESS:
      return [...state, { ...action.clientLedgerEntry }];
    case types.UPDATE_CLIENT_LEDGER_SUCCESS:
      return state.map(entry => (entry.id === action.clientLedgerEntry.id ? action.clientLedgerEntry : entry));
    case types.LOAD_CLIENT_LEDGER_SUCCESS:
      return action.clientLedger;
    case types.DELETE_CLIENT_LEDGER_OPTIMISTIC:
      return state.filter(entry => entry.id !== action.clientLedgerEntry.id);
    default:
      return state;
  }
};

export default clientLedgerReducer;
